import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function YetiskindeDikkatTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['yetiskinde-dikkat-belirtileri-testi']} />;
}
